export enum SidePanelTabs {
  Content,
  Citation,
  Comment,
}
